import { useState, useCallback } from "react";
import { httpsCallable } from "firebase/functions";
import { getFirebaseFunctions } from "../firebase";

interface Request {
  userId: string;
  factoringId: string;
}

export const useDeleteFactoring = () => {
  const [isDeleting, setIsDeleting] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const deleteFactoring = useCallback(async (
    userId: string,
    factoringId: string,
  ) => {
    setIsDeleting(true);
    setError(null);

    const functions = getFirebaseFunctions();

    try {
      const deleteFactoringFunction = httpsCallable<Request, void>(
        functions,
        "admin_deleteFactoring",
      );

      await deleteFactoringFunction({ userId, factoringId });
      setIsDeleting(false);

      return {
        success: true,
      };
    } catch (error: unknown) {
      console.error("ファクタリング削除エラー:", error);
      const errorMessage = error instanceof Error ? error : new Error("ファクタリングの削除に失敗しました");
      setError(errorMessage);
      setIsDeleting(false);

      return {
        success: false,
      };
    }
  }, []);

  return { deleteFactoring, isDeleting, error };
};
